import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PrintIcon from "@mui/icons-material/Print";

const PatientPrintPreviewDialog = ({
  open,
  title = "Document",
  documentHtml = "",
  loading = false,
  onClose,
  onPrint,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="md"
    scroll="paper"
    sx={{
      "& .MuiDialog-container": {
        alignItems: "flex-start",
        paddingTop: { xs: 2, md: 3 },
        paddingBottom: { xs: 2, md: "80px" },
      },
    }}
    PaperProps={{
      sx: {
        mx: 2,
        mt: 0,
        mb: 0,
        maxWidth: 900,
        width: "100%",
        maxHeight: "calc(100vh - 140px)",
        height: "calc(100vh - 140px)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      },
    }}
  >
    <DialogTitle sx={{ flexShrink: 0, py: 1.5 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>
    <DialogContent
      dividers
      sx={{
        p: 0,
        flex: "1 1 auto",
        minHeight: 0,
        overflow: "auto",
        backgroundColor: "#f5f7fa",
      }}
    >
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={360}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Box
          component="iframe"
          title={title}
          srcDoc={documentHtml || ""}
          sx={{
            width: "100%",
            height: "100%",
            minHeight: "100%",
            border: 0,
            display: "block",
            backgroundColor: "#fff",
          }}
        />
      )}
    </DialogContent>
    <DialogActions
      sx={{
        flexShrink: 0,
        px: 3,
        py: 1.5,
        gap: 1,
        backgroundColor: "#fff",
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={onClose}
        sx={{ textTransform: "none", fontWeight: 600 }}
      >
        Close
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        startIcon={<PrintIcon />}
        onClick={onPrint}
        disabled={loading || !documentHtml}
        sx={{ textTransform: "none", fontWeight: 600 }}
      >
        Print
      </Button>
    </DialogActions>
  </Dialog>
);

export default PatientPrintPreviewDialog;
